import type { CalloutType } from '@bangle.io/prosemirror-plugins';

/**
 * Localized default titles shown for callouts without an explicit title.
 * Kept in one place so the live editor and the read-only view agree.
 */
export function getCalloutDefaultTitles(): Record<CalloutType, string> {
  return t.app.editor.callout;
}
